/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */
import _ from 'lodash';
import Backbone from 'backbone';
import Radio from 'backbone.radio';

import HeaderBarView from '@/views/HeaderBarView';
import './CustomerHeaderView.css';

const CustomerHeaderView = HeaderBarView.extend({
  className: 'customer-header-view header-bar-view clearfix',

  initialize() {
    const columns = [
      {
        name: 'otdsUserId',
        label: 'User ID'
      },
      {
        name: 'fullName',
        label: 'Name'
      },
      {
        name: 'email',
        label: 'Email'
      },
      {
        name: 'telephone',
        label: 'telephone'
      },
      {
        name: 'email',
        label: 'Email'
      }
    ];
    this.options.columns = new Backbone.Collection(columns);
    this.listenTo(Radio.channel('customer'), 'update:header', (data) => {
      const fullName = `${data.firstName} ${data.lastName}`;
      this.model.set('fullName', fullName);
      _.forOwn(data, (value, key) => {
        this.model.set(key, value);
      });
    });
  }
});

export default CustomerHeaderView;
